//


window.setupAddressLookup = function (config) {

	var maxAddressDisplayCount = 50;

	var btnCantFindAddress = document.getElementById('BtnCantFindAddress');
	var btnChangePostcode = document.getElementById('BtnChangePostcode');
	var btnManualEntry = document.getElementById('BtnManualEntry');
	var btnReset = document.getElementById('BtnAnotherPostcode');

	// strings...
	var pleaseEnterAddressText = config.pleaseEnterAddressText;
	var noResultsText = "We could not find this address, please try entering it again or click the <i>I can't find my address in the list</i> link";
	var selectAddressText = config.selectAddressText;
	var freetextAddressElementID = config.FreetextAddressElementID
	var addressLine1ElementID = config.AddressLine1ElementID
	var addressLine2ElementID = config.AddressLine2ElementID
	var addressLine3ElementID = config.AddressLine3ElementID
	var townOrCityElementID = config.TownOrCityElementID
	var countyElementID = config.CountyElementID
	var postcodeElementID = config.PostcodeElementID
	var countryElementID = config.CountryElementID

	var inputFreetextAddress = document.getElementById(freetextAddressElementID);

	var recordIdFld = document.getElementById('RecordID');
	var recordId = recordIdFld !== null ? recordIdFld.value : "";

	var currentFocus = 0;
	var prevAddressVal = '';

	// 
	// trying different events to catch autofilled addresses
	inputFreetextAddress.addEventListener('blur', addressFieldChange, false);
	inputFreetextAddress.addEventListener('change', addressFieldChange, false);
	inputFreetextAddress.addEventListener('input', addressFieldChange, false);

	inputFreetextAddress.addEventListener('keydown', function (e) {
		if (e.keyCode == 40) {
			// down
			currentFocus++;
			addFocus();
		} else if (e.keyCode == 38) {
			// up
			currentFocus--;
			addFocus();
		} else if (e.keyCode == 13) {
			// enter
			var currentAddressItem = document.getElementsByClassName('address-option--selected');
			if (currentAddressItem.length > 0) {
				var id = currentAddressItem[0].getAttribute('data-address-id');
				if (id != '') {
					retrieveAddress(id);
				}
			}
			e.preventDefault();
			e.stopPropagation();
			return false;
		} else if (e.keyCode != 32) {
			// not the spacebar
			return false;
		} else {
			// lookup is now triggered on change event
			// console.log('looking up postcode...');
			// currentFocus = 0;
			// findAddress()
		}
	})

	inputFreetextAddress.addEventListener('focus', function (e) {
		currentFocus = 0;
		findAddress()
	})

	btnCantFindAddress.addEventListener('click', function () {
		resetAll();
		window.hasSelectedAddress = true;
		enableContinue();
		showAddressFields();
	})

	btnChangePostcode.addEventListener('click', function () {
		resetAll();
	})

	btnManualEntry.addEventListener('click', function () {
		window.hasSelectedAddress = true;
		enableContinue();
		showAddressFields();
	})

	btnReset.addEventListener('click', function () {
		resetAll();
	})

	// js enabled => show Lookup or 'Change' button 
	if (typeof (hasAddressLines) !== 'undefined' && hasAddressLines === true) {
		console.log('hasAddressLines: ' + hasAddressLines);
		doShowChangeButton();
	} else {
		console.log('hasAddressLines: ' + hasAddressLines);
		doShowAddressLookup();
	}

	function addressFieldChange() {
		var newValue = inputFreetextAddress.value;

		// the value to lookup has changed
		if (newValue.trim() != prevAddressVal) {

			prevAddressVal = newValue.trim();

			currentFocus = 0;
			findAddress()
		}
	}

	function addFocus() {

		var addressItems = document.getElementsByClassName('address-option');
		var currentAddressItem = document.getElementsByClassName('address-option--selected')

		if (currentFocus < 0) {
			currentFocus = 0;
		}

		if (currentFocus > addressItems.length) {
			currentFocus = 0;
		}

		if (currentAddressItem.length) {
			currentAddressItem[0].classList.remove('address-option--selected');
		}

		addressItems[currentFocus - 1].classList.add('address-option--selected');
	}

	function showError(message, hideLookup) {

		if (hideLookup === true) {
			showAddressFields();
			hideChangeButton();
			enableContinue();
		}

		var error = document.getElementById("AddressLookupErrorMessage");
		error.innerHTML = message;
		error.style.display = "block";
		error.classList.remove('field-validation-valid');

		setTimeout(function () {
			error.style.display = "none";
			error.classList.add('field-validation-valid');
		}, 10000)
	}

	function findAddress(SecondFind) {

		window.hasSelectedAddress = false;

		disableContinue();

		var postcode = inputFreetextAddress.value.trim();

		if (postcode === '') {
			// showError(pleaseEnterAddressText);
			return;
		}

		var Container = "";

		if (SecondFind !== undefined) {
			Container = SecondFind;
		}


		var resultBox = document.getElementById("AddressLookupResult");

		// remove any existing results
		if (resultBox.childNodes.length > 0) {
			var selectBox = document.getElementById("mySelect");
			selectBox.parentNode.removeChild(selectBox)
		}

		if (postcode !== '') {

			var xmlhttp = new XMLHttpRequest();

			xmlhttp.onreadystatechange = function () {
				if (xmlhttp.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4

					hideLoader();

					if (xmlhttp.status == 200) {
						var data = JSON.parse(xmlhttp.responseText);

						// remove any existing results
						if (resultBox.childNodes.length > 0) {
							var selectBox = document.getElementById("mySelect");
							selectBox.parentNode.removeChild(selectBox)
						}

						if (data === '' || data.Items === undefined || data.Items.length == 0) {

							// no results
							showError(noResultsText);
						}
						else if (data.Items.length == 1 && data.Items[0].Id === null) {

								// empty response, possible 3rd-party API error
								showError('Address lookup error', true);

						} else {

							if ((Container == SecondFind) || (data.Items && data.Items.length < maxAddressDisplayCount)) {

								var list = document.createElement("div");
								list.setAttribute("id", "mySelect");
								resultBox.appendChild(list);

								// build selectable list of address results
								for (var i = 0; i < data.Items.length; i++) {
									var option = document.createElement("div");
									option.innerText = data.Items[i].Text + " " + data.Items[i].Description;
									option.setAttribute("class", 'address-option ' + data.Items[i].Type);
									option.setAttribute("data-address-id", data.Items[i].Id);

									// click to select address
									option.addEventListener('click', function () {
										var id = this.getAttribute('data-address-id');
										if (id != '') {
											retrieveAddress(id);
										}
									})

									list.appendChild(option);
								}

								// show the address options
								document.getElementById('AddressLookupResult').style.display = '';

								// show the manual entry button
								btnCantFindAddress.style.display = '';

							} else {
								// too many addresses to display
								console.warn('More than ' + maxAddressDisplayCount + ' addresses returned.');
							}

						}
					}
					else if (xmlhttp.status == 400) {
						// doAddressesNoFound();
					}
					else {
						// doAddressesNoFound();
					}
				}
			};

			showLoader();
			xmlhttp.open("GET", "/Umbraco/Surface/AddressLookup/LookupAddresses?postcode=" + postcode + "&recordId=" + recordId + "&container=" + Container, true);
			xmlhttp.send();
		}
	};

	function retrieveAddress(id) {
		//

		if (id != '') {

			if (id.indexOf('-') > 0) {

				findAddress(id);

			} else {

				var xmlhttp = new XMLHttpRequest();

				xmlhttp.onreadystatechange = function () {
					if (xmlhttp.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
						if (xmlhttp.status == 200) {

							var data = JSON.parse(xmlhttp.responseText);

							if (data == '' || data.Items.length == 0) {
								showError(noResultsText);
							} else if (data.Items.length == 1 && typeof (data.Items[0].Error) != "undefined") {
								showError(data.Items[0].Description);
							}
							else {
								var res = data.Items[0];

								populateAddress(res);

								showAddressFields();

								// hide the address options
								document.getElementById('AddressLookupResult').style.display = 'none';

								// hide the manual entry button
								btnCantFindAddress.style.display = 'none';

								// hide the manula entry button
								document.getElementById('BtnManualEntry').style.display = 'none';
							}
						}
						else if (xmlhttp.status == 400) {
							//
						}
						else {
							//
						}
					}
				};

				xmlhttp.open("GET", "/Umbraco/Surface/AddressLookup/ResolveAddress?id=" + id + "&recordId=" + recordId, true);
				xmlhttp.send();

			}
		}
	}

	function showLoader() {
		var loader = document.getElementById('Loader').style.display = '';
	}

	function hideLoader() {
		var loader = document.getElementById('Loader').style.display = 'none';
	}

	//
	// Populate address fields based on a result
	//
	function populateAddress(addr) {

        //console.log(addr);

		if (document.getElementById(addressLine1ElementID) != null)
			document.getElementById(addressLine1ElementID).value = addr.Line1;

		if (document.getElementById(addressLine2ElementID) != null)
			document.getElementById(addressLine2ElementID).value = addr.Line2;

		if (document.getElementById(addressLine3ElementID) != null)
			document.getElementById(addressLine3ElementID).value = addr.Line3;

		if (document.getElementById(townOrCityElementID) != null)
			document.getElementById(townOrCityElementID).value = addr.City;

		if (document.getElementById(countyElementID) != null)
			document.getElementById(countyElementID).value = '';

		if (document.getElementById(postcodeElementID) != null)
			document.getElementById(postcodeElementID).value = addr.PostalCode;

		if (document.getElementById(countryElementID) != null)
			document.getElementById(countryElementID).value = addr.CountryName;

		hasSelectedAddress = true;

		enableContinue();
	}

	//
	// Clear address fields
	//
	function clearAddress() {

		if (document.getElementById(addressLine1ElementID) != null)
			document.getElementById(addressLine1ElementID).value = '';

		if (document.getElementById(addressLine2ElementID) != null)
			document.getElementById(addressLine2ElementID).value = '';

		if (document.getElementById(addressLine3ElementID) != null)
			document.getElementById(addressLine3ElementID).value = '';

		if (document.getElementById(townOrCityElementID) != null)
			document.getElementById(townOrCityElementID).value = '';

		if (document.getElementById(countyElementID) != null)
			document.getElementById(countyElementID).value = '';

		if (document.getElementById(postcodeElementID) != null)
			document.getElementById(postcodeElementID).value = '';

		if (document.getElementById(countryElementID) != null)
			document.getElementById(countryElementID).value = '';
	}

	//
	// Show all of the address fields and hide the address lookup
	//
	function showAddressFields() {
		var addressFields = document.getElementsByClassName('address-field');

		// show the address fields
		for (var i = 0; i < addressFields.length; i++) {
			addressFields[i].style.display = 'block';
		}

		// hide the lookup fields
		document.getElementById('AddressLookupFields').style.display = 'none';

		// show the change button
		document.getElementById('BtnChangePostcode').style.display = '';
	}

	//
	// Hide all of the address fields and show the address lookup
	//
	function showPostcodeFields() {
		var addressFields = document.getElementsByClassName('address-field');

		// hide the address fields
		for (var i = 0; i < addressFields.length; i++) {
			addressFields[i].style.display = 'none';
		}

		// show the lookup fields
		document.getElementById('AddressLookupFields').style.display = '';

		// hide the change button
		document.getElementById('BtnChangePostcode').style.display = 'none';
	}

	function hideChangeButton() {
		if (btnChangePostcode !== null) {
			btnChangePostcode.style.display = 'none';
		}
	}

	//
	// Reset to allow another lookup
	//
	function resetAll() {
		window.hasSelectedAddress = false;
		//disableContinue();
		currentFocus = 0;
		inputFreetextAddress.value = '';
		clearAddress();
		showPostcodeFields();
		// show the Lookup and manual entry buttons
		btnManualEntry.style.display = 'block';
	}

	//
	// Disable the Continue buton
	//
	function disableContinue() {
		var btn = document.getElementById("NextButton");

		if (btn) {
			btn.disabled = true;
		}
	}

	//
	// Enable the Continue buton
	//
	function enableContinue() {
		var btn = document.getElementById("NextButton");

		if (btn) {
			btn.disabled = false;
		}
	}

	function doShowAddressLookup() {

		var addressFlds = document.querySelectorAll('.address-field');
		var lookupFld = document.querySelector('#AddressLookupFields');
		var chngBtn = document.querySelector('#BtnChangePostcode');
		var manuBtn = document.querySelector('#BtnManualEntry');

		lookupFld.style.display = "";

		addressFlds.forEach((e) => {
			e.style.display = "none";
		})

		chngBtn.style.display = "none";
		manuBtn.style.display = "";
	}

	function doShowChangeButton() {
		var chngBtn = document.querySelector('#BtnChangePostcode');
		chngBtn.style.display = "";
	}
}

window.initAddressLookup = function () {

	//this.console.log('Initialising address lookup...');


	if (typeof (addressConfig) !== 'undefined') {
		window.setupAddressLookup(addressConfig);
	} else {
		//console.warn('Address Lookup configuration not found');
	}

	//setTimeout(function () {
	//	if (typeof (addressConfig) !== 'undefined') {
	//		window.setupAddressLookup(addressConfig);
	//	} else {
	//		console.warn('Address Lookup configuration not found');
	//	}
	//}, 50);
}

if (document.readyState !== 'loading') {
	window.initAddressLookup();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.initAddressLookup();
	});
}